import styled from 'styled-components';
import { colors } from 'styles/colors';
import { shadows } from 'styles/remoteControlShadows';

export const GraphTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 8px;
  background-color: ${colors.bg['weak-100']};
  height: 80px;
  min-width: 174px;
  box-shadow: ${shadows.shadow01};
`;

export const MonthContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;

  & > span {
    font-weight: 400;
    font-size: 12px;
    color: ${colors.text['main-900']};
    line-height: 20px;
    vertical-align: middle;
  }
`;

export const Circle = styled.div<{ color?: string }>`
  width: 8px;
  height: 8px;
  margin: 4px;
  border-radius: 9999px;

  ${({ color }) => (color ? `
    background-color: ${color};
  ` : '')}
`;
